import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/reset-forgot-password-screen';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { resetPassword } from '../../api/authentication.ts';
import { FORM_ERRORS } from '../../constants/form_errors.ts';

function ResetForgotPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      password: '',
      confirm_password: '',
    },
    validate: {
      password: (value) => (value.length < 8 ? FORM_ERRORS.PASSWORD_LENGTH_VALIDATION : null),
      confirm_password: (value, values) =>
        value !== values.password ? FORM_ERRORS.PASSWORD_CONFIRMATION_VALIDATION : null,
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    setIsLoading(true);
    resetPassword({ newPassword: values.password }, token)
      .then(() => {
        setIsLoading(false);
        setIsSuccessful(true);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsSuccessful(false);
        form.setErrors({
          password: error.response.data.fields?.find(
            (field: { fieldName: string; message: string }) => field.fieldName === 'newPassword',
          )?.message,
        });
      });
  };

  const handleClick = () => {
    navigate(LINKS.LOGIN);
  };

  return (
    <Screen
      form={form}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      handleClick={handleClick}
      success={isSuccessful}
    />
  );
}
export default ResetForgotPassword;
